import { Injectable } from '@angular/core';
import { ProductFiltersFieldId } from '@epicuro-next/models/product-filters';
import { APP_TOP_LEVEL_PATH } from '@epicuro-next/navigation/constants';
import { selectDeliveryShops } from '@epicuro-next/state/basket-state';
import { selectCurrentlyActiveDeliveryShop } from '@epicuro-next/state/config-strip-state';
import { selectFirstActiveDisplayValueOf } from '@epicuro-next/state/p-basket-state';
import { openOverlayOutlet } from '@epicuro-next/state/router-store';
import { getUTCAfternoon, isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';

import { preSelectFutureDeliveryPeriod } from '../actions';
import { activateConfigStrip } from '../actions/activate.actions';

@Injectable()
export class ConfigStripActivationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
  ) {}

  public preSelectFutureDeliveryPeriod$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activateConfigStrip),
      concatLatestFrom(() => [
        this.store.pipe(
          select(
            selectFirstActiveDisplayValueOf(ProductFiltersFieldId.Availability),
          ),
        ),
      ]),
      map(([, period]) => period),
      filter(isNonNullish),
      map((period) =>
        preSelectFutureDeliveryPeriod({ from: getUTCAfternoon(period) }),
      ),
    ),
  );

  public openOverlay$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activateConfigStrip),
      concatLatestFrom(() => [
        this.store.pipe(select(selectDeliveryShops)),
        this.store.select(selectCurrentlyActiveDeliveryShop),
      ]),
      map(([{ product }, [firstShop], activeShop]) => {
        const shop = activeShop ?? firstShop;
        const overlayPath = [
          APP_TOP_LEVEL_PATH.cs.path,
          product.brandId,
          product.parent?.productId ?? product.productId,
          product.productId,
        ];

        overlayPath.push(`${shop.accountId}_${shop.addressId}`);

        return openOverlayOutlet({ overlayPath });
      }),
    ),
  );
}
